<template>

    <div>

        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Lightbox</h2>

        <div class="preview-box" :style="{width : previewBoxWidth}">

            <vstyle>
                #bundle-lightbox-{{globalSettings.elementIdWeebly}} .fixed-element-overlay {
                    background: {{settingsFromWeebly.settings.overlayColor}};
                }

                #bundle-lightbox-{{globalSettings.elementIdWeebly}} .fixed-element {
                    max-width: {{settingsFromWeebly.settings.lightBoxWidth}}px;
                    {{settingsFromWeebly.settings.useShadow ? 'box-shadow: 0 7px 15px rgba(0,0,0,.3);':null}}
                }

                #bundle-lightbox-{{globalSettings.elementIdWeebly}} .fixed-element-body {
                    background: {{settingsFromWeebly.settings.bodyBackground}};
                }

                #bundle-lightbox-{{globalSettings.elementIdWeebly}} .fixed-element-title {
                    background: {{settingsFromWeebly.settings.titleBackground}};
                    border-bottom: 1px solid {{settingsFromWeebly.settings.titleBorder}};
                }
                #bundle-lightbox-{{globalSettings.elementIdWeebly}} .close-data-popup-button i {
                    color: {{settingsFromWeebly.settings.closeIconColor}};
                }
                
            </vstyle>

            <div :id="'bundle-lightbox-'+globalSettings.elementIdWeebly" class="fixed-element-wrapper" :data-popup-to-show="'bundle-lightbox-'+globalSettings.elementIdWeebly">
                <div class="fixed-element-overlay"></div>
                <div id="wsite-content" class="fixed-element wsite-elements wsite-not-footer">
                    <div class="fixed-element-title" v-if="settingsFromWeebly.settings.useTitle">
                        <div v-if="!globalSettings.elementGuidesOnlyDashboard">
                            {lightbox-title-{{globalSettings.elementIdWeebly}}:text}
                        </div>

                        <div class="lightbox-dummy-title" v-if="globalSettings.elementGuidesOnlyDashboard">Add title in Weebly editor</div>

                        <div class="close-data-popup-button">
                            <i class="fas fa-times"></i>
                        </div>
                    </div>

                    
                    <div class="fixed-element-body" :class="!settingsFromWeebly.settings.useTitle ? 'fixed-element-body-rounded-top':''">
                        <div v-if="!settingsFromWeebly.settings.useTitle">
                            <div class="close-data-popup-button-wrap">
                                <div class="close-data-popup-button">
                                    <i class="fas fa-times"></i>
                                </div>
                            </div>
                        </div>
                        <div class="lightbox-dummy-text" v-if="globalSettings.elementGuidesOnlyDashboard">You can populate the lightbox<br>with content in the Weebly editor.</div>
                        {bundle-lightbox-{{globalSettings.elementIdWeebly}}:content}
                    </div>
                    
                </div>
            </div>

        </div>

    </div>

</template>

<script>

export default {

    name: 'LightBox',

    data () {

        return {

            // uniqueId: 'button-'+Math.random().toString(36).substr(2, 16)
            lightBoxName: ''
            
        }
    },

    computed: {

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        }

    },

    components: {

        'vstyle': {
            render: function (createElement) {

                return createElement('style', this.$slots.default)
                
            }
        }

    },
    
    mounted() {

        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';

.preview-box {
    position: relative;

    .fixed-element-wrapper {
        position: static;
        opacity: 1;
    }

    .fixed-element-overlay {
        // padding: 20px;
        position: absolute;
        // height: auto;
    }

    .fixed-element {
        height: auto;
        opacity: 1;
        transform: none;
    }

    .fixed-element-body {
        font-size: 0;
    }

    .fixed-element-body .close-data-popup-button i {
        font-size: 14px;
    }

    .lightbox-dummy-title {
        font-size: 18px;
        padding: 15px;
    }
    .lightbox-dummy-text {
        padding: 15px;
        border: 3px dashed rgba(0,0,0,.2);
        font-size: 14px;
        margin: 20px auto;
    }

}

</style>



// WEBPACK FOOTER //
// src/components/elements/LightBox.vue